/* eslint-disable react/destructuring-assignment */
import { IconClearAll, IconSearch, IconTool } from '@tabler/icons-react';
import { Button, Group, Paper, SimpleGrid, Space, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

type FilterData = {
  servico: string;
};

type FilterProps = {
  filter(data: FilterData): void;
  clear(): void;
  loading: boolean;
};

function ServiceFormSearchFilter(props: FilterProps) {
  const form = useForm<FilterData>({
    initialValues: {
      servico: '',
    },
  });

  return (
    <form onSubmit={form.onSubmit(props.filter)}>
      <Paper shadow="xs" p="md" withBorder>
        <SimpleGrid cols={2}>
          <TextInput
            leftSection={<IconTool size={15} />}
            label="Serviço"
            description="Filtro: contém"
            placeholder="Todos..."
            maxLength={500}
            {...form.getInputProps('servico')}
          />
          <Group>
            <Button
              style={{ marginTop: 44 }}
              color="secondary"
              leftSection={<IconClearAll size={18} />}
              disabled={props.loading}
              onClick={() => {
                form.reset();
                props.clear();
              }}
            >
              Limpar
            </Button>
            <Button
              style={{ marginTop: 44 }}
              leftSection={<IconSearch size={18} />}
              type="submit"
              loading={props.loading}
            >
              Pesquisar
            </Button>
          </Group>
        </SimpleGrid>
      </Paper>
      <Space h="xl" />
    </form>
  );
}

export { ServiceFormSearchFilter };
export type { FilterData };
